import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex align-center justify-center h-full"
}



// #props

export default /*@__PURE__*/_defineComponent({
  __name: 'AppCardInfo',
  props: {
  cardTitle: {
    type: String,
    default: ''
  },
  loading: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "bid-card" }, {
    default: _withCtx(() => [
      (__props.cardTitle)
        ? (_openBlock(), _createBlock(_component_v_card_title, {
            key: 0,
            class: "bid-card__title"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.cardTitle), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_card_text, { class: "bid-card__content" }, {
        default: _withCtx(() => [
          (__props.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  size: "48",
                  color: "#18A1C8"
                })
              ]))
            : _renderSlot(_ctx.$slots, "default", {}, undefined, undefined, 1)
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})